import { useTranslation } from "react-i18next";
import { expandRoles } from "utils/authRules";

// Research roles that see beyond their own teams (the server keeps the same list
// in apps/legal_research/access.py).
const RESEARCH_STAFF_ROLES = [
  "LegalResearchCoordinator",
  "LRDIFUDDirector",
  "LRDIFUDeputy",
  "GeneralAttorney",
  "OAGBManagementHead",
  "Registrar",
];

// A user who works on research only as a team prosecutor (legal research
// prosecutors, and awareness / translation prosecutors the director puts on a
// research team).
export const isTeamProsecutorOnly = (roles: string[] = []) => {
  const expanded = expandRoles(roles);
  return (
    expanded.includes("LegalResearchProsecutor") &&
    !expanded.some((r) => RESEARCH_STAFF_ROLES.includes(r))
  );
};

// Is the user on the request's prosecutor list or on one of its research teams?
export const isResearchMember = (req: any, userId?: string) =>
  !!userId &&
  !!(
    req?.prosecutor_assignments?.some(
      (p: any) => p?.prosecutor_user_id === userId,
    ) ||
    req?.internal_topic_assignment?.some(
      (p: any) => p?.prosecutor_user_id === userId,
    ) ||
    req?.research_teams?.some((team: any) =>
      team?.prosecutors?.some((p: any) => p?.prosecutor_user_id === userId),
    )
  );

export function NotTeamMember() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-1 items-center justify-center p-8">
      <div className="max-w-md w-full bg-white border border-gray-200 rounded-lg shadow-sm p-6 text-center">
        <h2 className="text-lg font-semibold text-gray-900 mb-2">
          {t("NotTeamMemberTitle")}
        </h2>
        <p className="text-sm text-gray-600">{t("NotTeamMemberMessage")}</p>
      </div>
    </div>
  );
}
